import { render, staticRenderFns } from "./BalanceInfo.vue?vue&type=template&id=677d900c&scoped=true&"
var script = {}
import style0 from "./BalanceInfo.vue?vue&type=style&index=0&id=677d900c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d900c",
  null
  
)

export default component.exports